import { BehaviorSubject } from "rxjs";

export default class CardService {
  [x: string]: any;

  static $inject = ['StripeElements', 'Card', 'Toast', 'AmplitudeService'];
  public onSavingCardProcess = new BehaviorSubject<boolean>(opener);

  constructor(StripeElements, Card, Toast, AmplitudeService) {
    this.StripeElements = StripeElements;
    this.Card = Card;
    this.toast = Toast;
    this.Amplitude = AmplitudeService;
    this.changingCard = false;
  }

  save(cardStripeElement) {
    this.onSavingCardProcess.next(true);
    return this.StripeElements.createPaymentMethod('card', cardStripeElement)
      .then(result => {
        if (result.error && result.error.code) {
          this.toast.error(result.error.message);
        } else {
          return this.serviceStripePaymentMethod(result.paymentMethod)
        }
      })
      .then(() => {
        this.toast.success();
        this.onSavingCardProcess.next(false);
        if (this.changingCard) {
          this.cancelChanging();
          this.toast.success();
          return this.Amplitude.logEvent('Panel: Credit card changed');
        } else {
          this.toast.success();
          return this.Amplitude.logEvent('Panel: Credit card saved');
        }
      })
      .catch(res => {
        if (res.message) {
          this.toast.error(res.message);
        }
        // TODO the part below is only for Harvest specific error received as JSON
        //  and can be removed when stop using Harvest
        else if (res.data && res.data.length && res.data[0].indexOf('{') > -1) {
          const message = JSON.parse(res.data[0]).message;
          const uniqueMessage = message === 'Name has already been taken' ? 'PLANS.CARD_NAME_HARVEST_ERROR' : message;
          this.toast.error(uniqueMessage);
        }
        // --------- the end ---

        this.cancelChanging();
        this.onSavingCardProcess.next(false);
      });
  }

  changeCard() {
    this.changingCard = true;
  }

  cancelChanging() {
    this.changingCard = false;
  }

  isChanging() {
    return this.changingCard;
  }

  serviceStripePaymentMethod(paymentMethod) {
    return this.Card.save({paymentMethodId: paymentMethod.id}).$promise;
  };
}
